<template>

    <div class="notification" :class=" 'is-' + context">

        <button @click="sendRemoveEvent" class="delete"></button>

        <div class="notification_content_container">
            <div class="notification_icon">
                <i v-if="context == 'info'" class="zmdi zmdi-info"></i>
                <i v-if="context == 'danger'" class="zmdi zmdi-alert-triangle"></i>
                <i v-if="context == 'success'" class="zmdi zmdi-badge-check"></i>
            </div>
            <div class="notification_content">
                <slot />
            </div>
        </div>
    </div>

</template>


<script>
export default {
    name: 'alert',
    props: {
        context: {
            type: String,
            required: true
        }
    },
    mounted(){
        setTimeout(() => { this.sendRemoveEvent() }, 3000)
    },
    methods: {
        sendRemoveEvent(){
            this.$emit("close")
        }
    }
}


</script>

<style lang="scss" scoped>
.notification{
    z-index: 99;
    border-radius: 3px!important;
    width: 400px;
    position: fixed;

    right: 30px;
    bottom: 30px;
    .notification_content_container{
        display: flex;
        align-items: center;
        .notification_icon{
            font-size: 32px;
            margin-right: 20px;
        }
    }
}
</style>